import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/debt-snowball',
  component: () => import('../../routes/DebtSnowballCalculator.svelte'),
  card: {
    id: 'debt-snowball-calculator',
    title: 'Debt Snowball Calculator',
    description: 'Pay off debt using the snowball method — smallest balance first for quick wins and growing momentum.',
    icon: 'ac_unit',
    iconBgClass: 'bg-sky-50',
    iconTextClass: 'text-sky-600',
    href: '/debt-snowball-calculator',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Debt Snowball Calculator – Pay Off Debt Fast with the Snowball Method',
    description: 'Free debt snowball calculator to plan your debt payoff strategy. Enter your debts, see month-by-month schedule, and discover how quickly you can be debt-free by targeting smallest balances first.',
  },
};

export default meta;